/* @flow */

import { blueGrey, evenLighterGrey } from '@braindate/ui/lib/token/palette';
import avatarSizes from 'src/shared/ui/component/image/setting/avatarSizes';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '100%',
    width: ({ variant }: ThemeFunction<{ variant: string }>) =>
      avatarSizes[variant],

    backgroundColor: evenLighterGrey,
    borderRadius: '50%',
    color: blueGrey,

    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1,
    textTransform: 'uppercase',
    borderColor: ({ theme }: ThemeFunction) => theme.accentColor,
    aspectRatio: 1,
    borderWidth: 2,
  },
};
